import React, { useEffect, useState } from "react";
import { ArrowDown } from "lucide-react";
import { AGENCY } from "../mock";
import Logo from "./Logo";

export default function Hero() {
  const [typed, setTyped] = useState("");
  const full = "agence de communication indépendante.";

  useEffect(() => {
    let i = 0;
    const t = setInterval(() => {
      i++;
      setTyped(full.slice(0, i));
      if (i >= full.length) clearInterval(t);
    }, 40);
    return () => clearInterval(t);
  }, []);

  return (
    <section id="home" className="relative min-h-screen flex flex-col justify-center py-32 px-6 md:px-10 overflow-hidden">
      {/* Background number */}
      <div className="absolute -top-16 -right-8 md:-right-16 pointer-events-none select-none">
        <div className="font-display font-bold text-white/[0.03] text-[280px] md:text-[520px] leading-none tracking-tighter">
          2026
        </div>
      </div>

      {/* Tag row */}
      <div className="relative max-w-[900px] mx-auto w-full text-center">
        {/* Autoplay agency video */}
        <div className="mx-auto mb-10 md:mb-14 rounded-xl overflow-hidden border border-white/10 shadow-2xl bg-black/40 max-w-[720px] aspect-video">
          <video
            key="hero-video"
            autoPlay
            muted
            loop
            playsInline
            preload="metadata"
            className="w-full h-full object-cover block"
          >
            <source
              src="/media/agence-des-gens.mp4"
              type="video/mp4"
            />
          </video>
        </div>

        <div className="flex items-center justify-center gap-3 mb-8 md:mb-10 font-mono text-xs md:text-sm text-white/50 uppercase tracking-widest">
          <span className="inline-block w-2 h-2 rounded-full bg-[#FF5B24] animate-pulse" />
          <span>Paris — Barcelone — Los Angeles</span>
          <span className="hidden md:inline">/</span>
          <span className="hidden md:inline">Depuis 2016</span>
        </div>

        <h1 className="font-display font-medium text-white text-[22px] leading-[1.25] md:text-[32px] lg:text-[38px] tracking-[-0.02em] max-w-3xl mx-auto">
          «&nbsp;Stratégie{" "}
          <span className="font-serif-i font-normal text-[#FF5B24]">puissance</span>{" "}
          Création&nbsp;» pour générer de la{" "}
          <span className="font-serif-i font-normal">valeur</span>{" "}
          et des{" "}
          <span className="font-serif-i font-normal text-[#FF5B24]">résultats</span>.
        </h1>

        <div className="mt-10 md:mt-14 flex flex-col items-center gap-8">
          <p className="font-mono text-sm md:text-base text-white/60 max-w-md">
            <Logo showTagline={false} /> l'agence des gens — {typed}
            <span className="cursor-blink text-[#FF5B24]">_</span>
          </p>

          <a
            href="#cas"
            className="group inline-flex items-center gap-3 text-sm text-white/80 hover:text-white"
          >
            <span className="w-12 h-12 rounded-full border border-white/20 flex items-center justify-center group-hover:bg-[#FF5B24] group-hover:border-[#FF5B24] transition-all">
              <ArrowDown className="w-4 h-4" />
            </span>
            Voir les réalisations
          </a>
        </div>
      </div>

      {/* Bottom marquee-like ticker */}
      <div className="relative mt-16 md:mt-24 border-t border-white/10 pt-4 max-w-[1440px] mx-auto w-full">
        <div className="flex justify-between font-mono text-[10px] md:text-xs text-white/40 uppercase tracking-widest">
          <span>{AGENCY.years} ans</span>
          <span className="hidden sm:inline">{AGENCY.team} collaborateurs</span>
          <span>B2C · B2B</span>
          <span className="hidden sm:inline">{AGENCY.offices.length} bureaux</span>
        </div>
      </div>
    </section>
  );
}



